export default __webpack_public_path__ + "static/media/qr-code.1b7062d9.svg";